import React from 'react'
import './Actions.css'

const Action = (props) => {
  if (props.disabled) {
    return (
      <a
        className='action action--disabled'
      >
        <i className='material-icons'>{props.icon}</i>
      </a>
    )
  } else {
    return (
      <a
        className={props.color ? 'action action--color' : props.dark ? 'action action--dark' : 'action action--light'}
        onClick={(ev) => {
          ev.preventDefault()
          props.onClick()
        }}
        href='#action'
      >
        <i className='material-icons'>{props.icon}</i>
      </a>
    )
  }
}

const ActionBtn = (props) => (
  <a
    className='action_plus'
    onClick={(ev) => {
      ev.preventDefault()
      props.onClick()
    }}
    href='#action'>
    <i className='material-icons'>{props.icon}</i>
  </a>
)

export { Action, ActionBtn }
